/**
 * Blok alanları — YES-185.
 *
 * Her blok türü için ayrı bir form yazmak yerine alanları VERİ olarak
 * tanımlıyoruz: on altı blok, on altı bileşen demekti ve yeni bir blok her
 * seferinde yeni bir ekran. Burası bir tablo; düzenleyici onu okuyor.
 *
 * Adlar API'deki blok `data` anahtarlarıyla aynı; sunucu `data`yı serbest
 * bırakıyor (modules/content/blocks.py), sözleşme burada duruyor.
 */
export type Alan =
  | { tur: 'metin'; ad: string; etiket: string; ipucu?: string; yer?: string }
  | { tur: 'uzunMetin'; ad: string; etiket: string; ipucu?: string; yer?: string }
  | { tur: 'secim'; ad: string; etiket: string; secenekler: [string, string][] }
  | { tur: 'liste'; ad: string; etiket: string; tekil: string; alanlar: Alan[] }

export const BLOK_ALANLARI: Record<string, Alan[]> = {
  hero: [
    { tur: 'metin', ad: 'eyebrow', etiket: 'Etiket', yer: '1.284 üye · 1998’den beri' },
    { tur: 'metin', ad: 'title', etiket: 'Başlık', yer: 'Derneğin ortak sesi' },
    { tur: 'uzunMetin', ad: 'body', etiket: 'Açıklama' },
    {
      tur: 'metin',
      ad: 'image_url',
      etiket: 'Görsel adresi',
      ipucu: 'Boşsa marka renginde bir alan görünür.',
    },
    {
      tur: 'secim',
      ad: 'background',
      etiket: 'Arka plan',
      secenekler: [
        ['marka-acik', 'Marka açık tonu'],
        ['beyaz', 'Beyaz'],
        ['marka', 'Marka rengi'],
        ['koyu', 'Koyu'],
      ],
    },
    {
      tur: 'liste',
      ad: 'buttons',
      etiket: 'Butonlar',
      tekil: 'Buton',
      alanlar: [
        { tur: 'metin', ad: 'label', etiket: 'Yazı', yer: 'Üye ol' },
        { tur: 'metin', ad: 'href', etiket: 'Adres', yer: '/uye' },
      ],
    },
  ],
  text: [
    { tur: 'metin', ad: 'title', etiket: 'Başlık' },
    {
      tur: 'uzunMetin',
      ad: 'body',
      etiket: 'Metin',
      ipucu: 'Boş satır bırakarak paragraf ayırın.',
    },
  ],
  cards: [
    { tur: 'metin', ad: 'title', etiket: 'Bölüm başlığı' },
    {
      tur: 'liste',
      ad: 'items',
      etiket: 'Kartlar',
      tekil: 'Kart',
      alanlar: [
        { tur: 'metin', ad: 'eyebrow', etiket: 'Etiket' },
        { tur: 'metin', ad: 'title', etiket: 'Başlık' },
        { tur: 'uzunMetin', ad: 'body', etiket: 'Metin' },
        { tur: 'metin', ad: 'href', etiket: 'Bağlantı' },
      ],
    },
  ],
  cta: [
    { tur: 'metin', ad: 'title', etiket: 'Başlık' },
    { tur: 'uzunMetin', ad: 'body', etiket: 'Açıklama' },
    { tur: 'metin', ad: 'label', etiket: 'Buton yazısı', yer: 'Üye ol' },
    { tur: 'metin', ad: 'href', etiket: 'Buton adresi', yer: '/uye' },
  ],
  gallery: [
    { tur: 'metin', ad: 'title', etiket: 'Bölüm başlığı' },
    {
      tur: 'liste',
      ad: 'images',
      etiket: 'Görseller',
      tekil: 'Görsel',
      alanlar: [
        { tur: 'metin', ad: 'url', etiket: 'Adres' },
        { tur: 'metin', ad: 'alt', etiket: 'Alternatif metin', ipucu: 'Ekran okuyucular için.' },
        { tur: 'metin', ad: 'caption', etiket: 'Alt yazı' },
      ],
    },
  ],
  faq: [
    { tur: 'metin', ad: 'title', etiket: 'Bölüm başlığı' },
    {
      tur: 'liste',
      ad: 'items',
      etiket: 'Sorular',
      tekil: 'Soru',
      alanlar: [
        { tur: 'metin', ad: 'question', etiket: 'Soru' },
        { tur: 'uzunMetin', ad: 'answer', etiket: 'Cevap' },
      ],
    },
  ],
  divider: [],
}

/** Dinamik bloklarda içerik modülden gelir; düzenlenebilen tek şey başlık. */
export const DINAMIK_ALANLAR: Alan[] = [{ tur: 'metin', ad: 'title', etiket: 'Bölüm başlığı' }]

export const DINAMIK_ACIKLAMA: Record<string, string> = {
  boards: 'İçerik Kurullar modülünden geliyor; kurulu güncelleyince site de güncellenir.',
  membership_application: 'Başvuru formu üye portalında; site oraya yönlendirir.',
  contact: 'İletişim bilgileri Ayarlar › Dernek ekranından geliyor.',
  events: 'Etkinlik paketi açıldığında dolacak.',
  news: 'Haber modülü geldiğinde dolacak.',
  documents: 'Doküman modülü geldiğinde dolacak.',
  courses: 'Akademi paketi açıldığında dolacak.',
  fee_payment: 'Aidat ödeme akışı üye portalında.',
  donation: 'Bağış akışı geldiğinde dolacak.',
}
